import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { CoverCarousel } from './CoverCarousel';
import { motion } from 'framer-motion';

export const HeroSplit = ({ covers = [] }) => {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Gradient background */}
      <div 
        aria-hidden="true" 
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(80%_60%_at_50%_0%,rgba(255,68,102,0.12),rgba(0,0,0,0)_70%)]"
      />

      <div className="container max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Left: Cover Carousel */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-5"
          >
            <CoverCarousel covers={covers} />
          </motion.div>

          {/* Right: Title & CTAs */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="lg:col-span-7"
          >
            <span className="uppercase tracking-[0.18em] text-xs text-muted-foreground font-ui">
              Brands & Bloggers
            </span>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
              Bold voices. <br className="hidden sm:block" />Braver brands.
            </h1>
            <p className="mt-5 max-w-[55ch] text-base md:text-[17px] text-muted-foreground leading-7">
              Interviews, features, and series at the intersection of creators and commerce. 
              Discover the stories shaping the future of brands and digital influence.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Button 
                asChild
                data-testid="hero-primary-cta"
                className="font-ui bg-primary hover:bg-[hsl(349,92%,58%)] shadow-[0_8px_30px_rgba(255,68,102,0.28)]"
              >
                <Link to="/features">Read Latest</Link>
              </Button>
              <Button 
                asChild
                variant="ghost" 
                data-testid="hero-secondary-cta"
                className="font-ui"
              >
                <Link to="/videos">Watch Series</Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};